import React, { useState, useEffect, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import debounce from "lodash.debounce";
import TooltipMaterial from "@material-ui/core/Tooltip";
import MaterialTooltip from "@material-ui/core/Tooltip";
import UploadDummy from 'web/assets/images/UploadDummy.png'
import * as moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineSearch, AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineVerticalAlignMiddle } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { ptPlusAdminOrderRequestsList, ptPlusExportAdminOrderRequestsList } from 'redux/actions/adminPtPlusOrderRequests';
import { deleteOrder } from "redux/actions/requestOrderPtplus";
import styled from "styled-components";
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import PtPlusPageInfoIcon from "web/assets/svg/PtPlusPageInfoIcon";
import { sepctFileDownload } from "redux/actions/adminPtPlusOrderRequests";
import { Heading, OrderDetailsWrapper, TableWrapper, DateWrapper, SearchWrapper, SelectWrapper, AdjustmentHeader } from './OrderStyled'
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import PdfDocument from './OrderDetailsPdf';
import PrinterIcon from "web/assets/svg/PtPlusOrderPrinterIcon";
import CsvDownloader from 'react-csv-downloader';
import EditIcon from "web/assets/svg/PtPlusUserEditIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import MultiSelectDropdownCheckbox from "web/components/MultiSelectDropdownCheckbox";

import AlertModal from 'web/components/AlertModal';
import YesNoModal from 'web/components/YesNoModal';
import ConfirmationModal from "web/components/ConfirmationModal";
import { Modal, ModalBody } from 'reactstrap';
import DatePicker from 'web/components/DatePicker';
import PaymentAdjustmentModal from './PaymentAdjustmentModal';
import { ClaimResolutioHeader } from '../../Claim/ClaimStyled';
import { Form, Formik } from 'formik';
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import { downloadFile } from 'redux/actions/helper/downloadFile';
import { deliveryReqOrderDeclineApi } from "redux/actions/myPickupOrders"
import { pickupOrderDeclineApi } from "redux/actions/myPickupOrders"
import WithdrawIcon from "web/assets/images/withdraw-icon.png";
import Tooltip from "@material-ui/core/Tooltip";

function PTPlusOrderRequestManagement({ scrollTop }) {
  const dispatch = useDispatch();
  let history = useHistory()
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [accordionOpenIndex, setAccordionOpenIndex] = useState()
  const [csvData, setCsvData] = useState([])
  const [finalData, setFinalData] = useState()
  const [tableSearch, setTableSearch] = useState('')
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [alertModal, setAlertModal] = useState(false);
  const [alertType, setAlertType] = useState();
  const [modalResult, setModalResult] = useState("");
  const toggleModal = () => setAlertModal(!alertModal);
  const [alertModalContent, setAlertModalContent] = useState('');

  const [deleteOrderDetails, setDeleteOrderDetails] = useState()
  const [yesNoModalOpen, setYesNoModalOpen] = useState(false);
  const yesNoToggleModal = () => setYesNoModalOpen(!yesNoModalOpen);
  const [yesNoModalContent, setYesNoModalContent] = useState();
  const [yesNoModalAlertType, setYesNoModalAlertType] = useState();

  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);

  const [totalPageNumber, settotalPageNumber] = useState(0);
  const filterList = [
    { label: 'Requested', value: 'REQUESTED' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Posted', value: 'POSTED' },
    { label: 'Assigned', value: 'ASSIGNED' },
    { label: 'Shipped', value: 'SHIPPED' },
    { label: 'Delivered', value: 'DELIVERED' },
    { label: 'Picked up', value: 'PICKEDUP' },
    { label: 'Claim', value: 'CLAIM' },
    { label: 'Complete', value: 'COMPLETE' },
    { label: 'Rescheduled', value: 'RESCHEDULED' },
    { label: 'Canceled', value: 'CANCELLED' },
    { label: 'Hold', value: 'HOLD' }
  ];
  const defaultFilterValues = ['REQUESTED', 'PENDING', 'POSTED', 'ASSIGNED', 'SHIPPED',
    'DELIVERED', 'PICKEDUP', 'CLAIM', 'COMPLETE', 'RESCHEDULED', 'CANCELLED', 'HOLD']

  const requestTypeOptions = [
    { label: 'All', value: 'ALL' },
    { label: 'Delivery', value: 'NEED' },
    { label: 'Pickup', value: 'PICKUP' }
  ];

  const [statusFilterValue, setStatusFilterState] = useState(defaultFilterValues)
  const [requestType, setRequestType] = useState([])
  const [paymentAdjustmentModal, setPaymentAdjustmentModal] = useState(false)
  const [clickedOrderDetails, setClickedOrderDetails] = useState()
  const token = localStorage.getItem("token")

  let headerArr = [
    { title: 'Ref No.' },
    { title: 'PO#' },
    { title: 'OD#' },
    { title: 'Customer Name' },
    { title: 'Location Name' },
    { title: 'City, ST' },
    { title: 'Type' },
    { title: 'Req. PU/Del' },
    { title: 'Qty, Type' },
    { title: 'Cust. $' },
    { title: 'Status' },
  ];

  let toDatePtplusOrderReq = new Date();
  let fromDatePtplusOrderReq = new Date();
  toDatePtplusOrderReq.setMonth(toDatePtplusOrderReq.getMonth() + 1);
  fromDatePtplusOrderReq.setMonth(fromDatePtplusOrderReq.getMonth() - 1)

  const [startDateValue, setStartDateValue] = useState(moment(fromDatePtplusOrderReq).format("MM/DD/YYYY"))
  const [endDateValue, setEndDateValue] = useState(moment(toDatePtplusOrderReq).format("MM/DD/YYYY"))

  const [userStateValues, setUserStateValues] = useState({
    fromDate: moment(fromDatePtplusOrderReq).format("MM/DD/YYYY"),
    toDate: moment(toDatePtplusOrderReq).format("MM/DD/YYYY"),
  });

  const [isExcludeCompleted, setIsExcludeCompleted] = useState(false)

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchOrderRequestsList(page, tableSearch);
  }, [statusFilterValue, requestType, isExcludeCompleted]);

  const fetchOrderRequestsList = async (page, tableSearch) => {
    let response = '';
    let data = {
      size: 15,
      number: page - 1,
      sort: "ASC",
      searchBy: tableSearch,
      statusList: statusFilterValue && statusFilterValue.length > 0 ? statusFilterValue : ["ALL"],
      fromDate: moment(userStateValues.fromDate).format('YYYY/MM/DD'),
      toDate: moment(userStateValues.toDate).format('YYYY/MM/DD'),
      requestType: requestType && requestType.length > 0 && requestType !== "ALL" ? [`${requestType}`] : ["NEED", "PICKUP"],
      excludeCompleteOrders: isExcludeCompleted,
    }
    response = await dispatch(ptPlusAdminOrderRequestsList(data, token));
    if (response.success) {
      if (response.data?.orderLists) {
        setFinalData(response.data?.orderLists)
        settotalPageNumber(response.data?.totalElements)
      } else setFinalData([])
      setPageCount(response.data?.totalPages)
    } else if (response.message === 'Request failed with status code 409') {
      setFinalData([])
    } else {
      if (response.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModalContent(response.message)
        setAlertModal(!alertModal)
      }
    }
  };

  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }
  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    setPage(1)
    let searchtext = e.target.value
    fetchOrderRequestsList(1, searchtext)
    // handleDebounceEmailCheck(searchtext)

  }
  const handleDebounceEmailCheck = useCallback(debounce((searchtext) => fetchOrderRequestsList(page, searchtext), 500), []);

  const handlePageChange = (e, val) => {
    scrollTop()
    setAccordionFunction()
    setPage(val)
    fetchOrderRequestsList(val, tableSearch);
  }

  const setAccordionFunction = index => {
    setAccordionOpenIndex(index)
  }

  const generatePdfDocument = async (e, documentData) => {
    let str = documentData?.equipmentRequirements.toString()
    str = str?.replace(/_/g, " ");
    str = str?.replace(/,/g, " / ");
    str = str?.toLowerCase();
    str = str?.replace(/\b\w/g, c => c.toUpperCase())

    const blob = await pdf((
      <PdfDocument
        pdfDocumentData={documentData}
        equipmentRequirements={str}

      />
    )).toBlob();
    saveAs(blob, 'Order Details');
  };

  const editOrder = (items, id, title) => {
    let obj = {
      id: id,
      items: items
    };

    dispatch({ type: "REQUESTED_ID", payload: obj });
    history.push('/ptplus-order-request')
  }

  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity

    if (items?.requestType === 'PickUp') return totalQuantity + ', NA'

    let material = items?.palletDetails?.material
    material = material?.toString()
    material = material?.toLowerCase();
    material = material?.replace(/\b\w/g, c => c.toUpperCase())
    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
    } else {
      if (items?.palletDetails?.condition.length !== 0) condition = items?.palletDetails?.condition
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
    }

    let palletType;
    let moisture = "";
    let size = "";
    let grade = "";
    let LWH
    let heatTreated = ''
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height

      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())
        return totalQuantity + ", " + material + "," + LWH + "-" + condition
      } else {
        return totalQuantity + ", " + material + ", " + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType
      if (items?.palletDetails?.moisture)
        moisture = ", " + items?.palletDetails?.moisture

      if (items?.palletDetails?.size) {
        if (items?.palletDetails?.size === 'Custom') {
          const length = items?.palletDetails?.length
          const width = items?.palletDetails?.width
          const height = items?.palletDetails?.height
          size = length + "x" + width + "x" + height
        } else {
          size = items?.palletDetails?.size
        }
      }

      if (items?.palletDetails?.grade)
        grade = ", " + items?.palletDetails?.grade

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }

      if (items?.palletDetails?.heatTreared) heatTreated = ', HT'

      return totalQuantity + ", " + size + "" + grade + "" + moisture + ", " + palletType + "-" + condition + heatTreated
    }
  }

  const columns = [
    { id: 'refNo', displayName: 'Ref No.' },
    { id: 'poNo', displayName: 'PO#' },
    { id: 'OrderNo', displayName: 'OD#' },
    { id: "customerName", displayName: "Customer Name" },
    { id: "locationName", displayName: "Location Name" },
    { id: "address", displayName: "Address - City ST" },
    { id: "type", displayName: "Type" },
    { id: 'equipment', displayName: 'Equipment' },
    { id: 'Material', displayName: 'Material' },
    { id: 'Condition', displayName: 'Condition' },
    { id: 'PalletType', displayName: 'Pallet Type' },
    { id: 'Moisture', displayName: 'Moisture' },
    { id: 'Size', displayName: 'Size' },
    { id: 'Grade', displayName: 'Grade' },
    { id: 'HeatTreated', displayName: 'Heat Treated' },
    { id: 'reqPuDel', displayName: 'Req. PU/Del' },
    { id: 'status', displayName: 'Status' },
    { id: 'qty', displayName: 'Quantity' },
    { id: 'custBase', displayName: 'Cust. Base $' },
    { id: 'invNo', displayName: 'Inv. No' },
    { id: 'invDate', displayName: 'Inv. Date' },
    { id: 'supplier', displayName: 'Supplier Name – City ST' },
    { id: 'supplierEmail', displayName: 'Supplier Email' },
    { id: 'supplierNumber', displayName: 'Supplier Phone' },
    { id: 'tenderDate', displayName: 'Tender Date' },
    { id: 'updateDate', displayName: 'Updated Date' },
    { id: 'actualDate', displayName: 'Actual Del/PU' },
    { id: 'orderCom', displayName: 'Order Comments' },
    { id: 'loadCom', displayName: 'Load Comments' },
  ]

  const csvFunction = async () => {
    let response = '';
    let tempFromDate = (moment(userStateValues.fromDate)).valueOf()
    tempFromDate = Math.trunc(tempFromDate / 1000)
    let tempToDate = (moment(userStateValues.toDate)).valueOf()
    tempToDate = Math.trunc(tempToDate / 1000) + 86399

    let data = {
      statusList: statusFilterValue && statusFilterValue.length > 0 ? statusFilterValue : ["ALL"],
      searchBy: tableSearch,
      fromDate: tempFromDate,
      toDate: tempToDate,
      requestType: requestType && requestType.length > 0 ? [`${requestType}`] : ["NEED", "PICKUP"],
    }
    response = await dispatch(ptPlusExportAdminOrderRequestsList(data, token));

    let tempCsvData = response?.data?.orderLists?.map(items => {
      const removeCommasLines = (text) => text?.trim()?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ");
      let palletsCondition = 'NA';
      if (items?.palletDetails?.condition && items?.palletDetails?.condition.length > 0) {
        let condition = items.palletDetails.condition;
        let newType = items?.palletDetails?.newConditionType;

        // Checking if newType is not an empty string or undefined
        if (newType && newType.trim() !== '') {
          palletsCondition = `${condition} (${newType === 'HARDWOOD' ? 'HW' : 'SW'})`;
        } else {
          palletsCondition = condition;
        }
      }

      let palletSize = items?.palletDetails?.size || 'NA';
      if (palletSize === 'Custom') {
        let length = items?.palletDetails?.length || 'NA';
        let width = items?.palletDetails?.width || 'NA';
        let height = items?.palletDetails?.height || 'NA';

        palletSize = `${length}x${width}x${height}`;
      }
      return ({
        refNo: items?.orderRefNumber,
        poNo: items?.poNumber || 'NA',
        OrderNo: items?.orderNo || 'NA',
        customerName: removeCommasLines(items.addressDTO?.locationName),
        locationName: removeCommasLines(items.addressDTO?.name),
        address: `${removeCommasLines(items.addressDTO?.street)} - ${removeCommasLines(items.addressDTO?.city)} ${stateConvert(removeCommasLines(items.addressDTO?.state)) || removeCommasLines(items.addressDTO?.state)}`,
        type: items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery',
        Material: items?.palletDetails?.material || 'NA',
        Condition: palletsCondition,
        PalletType: items?.palletDetails?.palletType || 'NA',
        Moisture: items?.palletDetails?.moisture || 'NA',
        Size: palletSize,
        Grade: items?.palletDetails?.grade || 'NA',
        HeatTreated: items?.palletDetails?.heatTreared ? 'Yes' : 'No',
        equipment: removeCommasLines(items.equipmentRequirements?.toString() || 'NA'),
        reqPuDel: moment(items?.requestDeliveryDate).format('MM-DD-YYYY') + ' ' + items?.deliveryFromTime + '-' + items?.deliveryToTime,
        status: items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus,
        qty: items?.quantityDetails?.totalQuantity || 'NA',
        custBase: items?.requestType === 'PickUp' ?
          ((items?.tenderDetails?.vendorPrice && items?.tenderDetails?.vendorPrice[0]) ? items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(' ') : 'NA')
          : items?.flatFee ? `$${items.flatFee.toFixed(2)}` : 'NA',
        invNo: items?.invoiceId || 'NA',
        invDate: items?.invoiceDate || 'NA',
        supplier: items?.tenderDetails?.postedTo
          ? `${removeCommasLines(items?.tenderDetails?.postedTo)} - ${removeCommasLines(items?.tenderDetails?.city)} ${items?.tenderDetails?.state}`
          : "NA",
        supplierEmail: (items?.tenderDetails?.email && items?.tenderDetails?.email[0]) ? `"${items.tenderDetails.email.join(', ')}"` : 'NA',
        supplierNumber: (items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? `"${items.tenderDetails.phoneNumber.join(', ')}"` : 'NA',
        tenderDate: items?.tenderDetails?.tenderDate || 'NA',
        updateDate: items?.updatedAt ? moment(items?.updatedAt * 1000).format('MM-DD-YYYY') : 'NA',
        actualDate: items?.actualDeliveryDate !== 0 ? moment(items?.actualDeliveryDate * 1000).format('MM-DD-YYYY') : 'NA',
        orderCom: removeCommasLines(items?.remark || 'NA'),
        loadCom: removeCommasLines(items?.tenderDetails?.comment || 'NA'),
      })
    })
    return tempCsvData.flat()
  }

  const handleStateChange = (event) => {
    setStatusFilterState(event.target.value)
    setPage(1)
  }

  const handleRequestTypeChange = (event) => {
    setRequestType(event.target.value)
    setPage(1)
  }

  const editPickupRequestOrder = (items) => {
    localStorage.setItem('ordRefNoForFetchReqPickOrd', items?.orderRefNumber)
    history.push("/ptplus-admin-request-pickup-order")
  }

  const deleteRequestOrderConfirmation = (items) => {
    setDeleteOrderDetails(items)
    setYesNoModalContent(items?.requestType === 'PickUp' ? 'Are you sure you want to delete the pickup order request?' : 'Are you sure you want to delete the order request?');
    setYesNoModalAlertType(items?.requestType === 'PickUp' ? 'deletePickupRequestOrder' : 'deleteRequestOrder')
    yesNoToggleModal();
  }

  const deleteRequestOrderFunction = async (confirmationAlertType) => {
    let data = {
      orderRefNumber: deleteOrderDetails?.orderRefNumber,
      emailId: [localStorage.getItem('email')],
      locationName: deleteOrderDetails?.addressDTO?.locationName
    }
    let response = await dispatch(deleteOrder(data, token));
    if (response?.data?.success) {
      setDeleteOrderDetails()
      setAlertModalContent(confirmationAlertType === 'deletePickupRequestOrder' ? 'Pickup order request deleted successfully!' : 'Order request deleted successfully!')
      setAlertType('success')
      toggleModal();
      setModalResult('successDelete')
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
        toggleModal();
      }
    }
  }

  const withdrawRequestOrderConfirmation = (items) => {
    setYesNoModalContent(items?.requestType === 'PickUp' ? 'Are you sure you want to withdraw the pickup order request?' : 'Are you sure you want to withdraw the order request?');
    setYesNoModalAlertType(items?.requestType === 'PickUp' ? 'withdrawPickupRequestOrder' : 'withdrawRequestOrder')
    setYesNoModal(true);
  }

  const withdrawRequestOrderFunction = async (confirmationAlertType) => {
    let data = {
      locationId: null,
      tenderId: clickedOrderDetails?.tenderId,
      comment: confirmationComment ?? null,
      tenderStatus: 'WITHDRAW'
    }
    let response
    if (clickedOrderDetails?.requestType === 'PickUp') {
      response = await dispatch(pickupOrderDeclineApi(data, token));
    } else {
      response = await dispatch(deliveryReqOrderDeclineApi(data, token));
    }
    if (response?.success) {
      setDeleteOrderDetails()
      setAlertModalContent(confirmationAlertType === 'withdrawPickupRequestOrder' ? 'Pickup order request withdrawn successfully!' : 'Order request withdrawn successfully!')
      setAlertType('success')
      toggleModal();
      setModalResult('successWithdraw')
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
        toggleModal();
      }
    }
  }

  const downloadDocs = async (imagePath) => {
    dispatch(downloadFile(imagePath));
  };

  const downloadDocsList = async (files) => {
    files.map(name => dispatch(downloadFile(name.fileName)))
  }

  return <>
    {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('PT_PLUS')))
      ? <div>
        {loaderVisible && <Spinner />}
        <div>
          <TableWrapper>
            <Heading>
              <h3>ORDER REQUESTS</h3>
              <div className='order-request-action-wrapper'>
                <div>
                  <Formik initialValues={{ excludeCompleted: false }}>
                    {() => (
                      <Form>
                        <CheckboxInput
                          name="excludeCompleted"
                          label="Exclude Completed"
                          handleSelect={(name, label, flag) => {
                            setIsExcludeCompleted(flag)
                            setPage(1);
                          }}
                        />
                      </Form>
                    )}
                  </Formik>
                </div>
                <DateWrapper>
                  <label>From</label>
                  <DatePicker
                    name="fromDatePtplusOrderReq"
                    placeholderText=""
                    maxDOBirth={userStateValues.toDate}
                    value={userStateValues.fromDate}
                    inputValue={startDateValue}
                    callBackFun={(date, value) => {
                      setStartDateValue(value)
                      if (moment(date, moment.ISO_8601, true).isValid()) {
                        setUserStateValues((prevState) => ({
                          ...prevState,
                          ["fromDate"]: moment(date).format("MM/DD/YYYY"),
                        }));
                      } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                        setUserStateValues((prevState) => ({
                          ...prevState,
                          ["fromDate"]: null,
                        }));
                      }
                    }}
                  />
                </DateWrapper>
                <DateWrapper>
                  <label style={{ marginLeft: '-10px' }}>To</label>
                  <DatePicker
                    name="toDatePtplusOrderReq"
                    placeholderText=""
                    minDOBirth={userStateValues.fromDate}
                    value={userStateValues.toDate}
                    inputValue={endDateValue}
                    callBackFun={(date, value) => {
                      setEndDateValue(value)
                      if (moment(date, moment.ISO_8601, true).isValid()) {
                        setUserStateValues((prevState) => ({
                          ...prevState,
                          ["toDate"]: moment(date).format("MM/DD/YYYY"),
                        }));
                      } else if (!date || date?.toString() === "Invalid Date") { // Check if date is null or undefined
                        setUserStateValues((prevState) => ({
                          ...prevState,
                          ["toDate"]: null,
                        }));
                      }
                    }}
                  />
                </DateWrapper>
                <button
                  disabled={!(userStateValues.fromDate && userStateValues.toDate)}
                  className={`button-style-green ${!(userStateValues.fromDate && userStateValues.toDate) && 'disabled-button'}`}
                  onClick={() => {
                    fetchOrderRequestsList(1, tableSearch);
                    setPage(1);
                  }}>
                  Submit
                </button>
                <SelectWrapper>
                  <MultiSelectDropdownCheckbox
                    placeholder="Status"
                    name="status"
                    options={filterList}
                    selectedStates={statusFilterValue}
                    setSelectedStates={setStatusFilterState}
                  />
                </SelectWrapper>
                <SelectWrapper>
                  <select
                    id="requestType"
                    value={requestType}
                    onChange={handleRequestTypeChange}
                  >
                    <option value="" disabled selected>Request Type</option>
                    {requestTypeOptions.map((option, index) => (
                      <option key={index} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                </SelectWrapper>
                <SearchWrapper>
                  <input type="text" placeholder='Search' value={tableSearch}
                    onChange={handleSearchChange} />
                  <AiOutlineSearch />
                </SearchWrapper>
                <CsvDownloader
                  filename="Order Request"
                  columns={columns}
                  datas={csvFunction}>
                  <button
                    className='button-style-green'>
                    Export
                  </button>
                </CsvDownloader>
              </div>
            </Heading>

            <OrderDetailsWrapper>
              <Table responsive>
                <thead>
                  <tr>
                    {headerArr.map((items, index) => (
                      <th key={index}>
                        {items.title}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {finalData && finalData.map((items, index) =>
                    <>
                      <tr key={index} className='user-list-table-styles'>
                        <td style={{ whiteSpace: 'nowrap' }}>{items.orderRefNumber || 'NA'}</td>
                        <td>{items.poNumber || 'NA'}</td>
                        <td>{items.orderNo || 'NA'}</td>
                        <td title={items.addressDTO?.name}>{items.addressDTO?.name?.length > 10
                          ? items.addressDTO.name.slice(0, 10) + "..."
                          : items.addressDTO?.name}</td>
                        <td title={items.addressDTO?.locationName}>{items.addressDTO?.locationName?.length > 10
                          ? items.addressDTO.locationName.slice(0, 10) + "..."
                          : items.addressDTO?.locationName}</td>
                        <td>{`${items.addressDTO?.city?.trim()}, ${stateConvert(items.addressDTO?.state?.trim()) || items.addressDTO?.state?.trim()}`}</td>
                        <td>{items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery'}</td>
                        <td>{moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</td>
                        <td>{orderType(items)}</td>
                        <td>
                          <Tooltip
                            placement="top"
                            arrow
                            title={
                              items?.requestType === 'PickUp'
                                ? (items?.tenderDetails?.vendorPrice && items?.tenderDetails?.vendorPrice[0]) ? items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(', ') : 'NA'
                                : items?.flatFee ? `$${items.flatFee.toFixed(2)}` : 'NA'
                            }
                            enterTouchDelay={5}
                            leaveTouchDelay={10000}
                          >
                            <span>
                              {items?.requestType === 'PickUp'
                                ? (items?.tenderDetails?.vendorPrice?.length > 1
                                  ? 'Multi'
                                  : ((items?.tenderDetails?.vendorPrice && items?.tenderDetails?.vendorPrice[0]) ? items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(', ') : 'NA'))
                                : items?.flatFee ? `$${items?.flatFee?.toFixed(2)}` : 'NA'}
                            </span>
                          </Tooltip>
                        </td>
                        <td className='expand-collapse-class'>
                          {items?.requestType === 'PickUp'
                            ?
                            <>
                              <div style={{ display: 'flex' }}>
                                <p className='order-status'>
                                  {items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}
                                </p>
                                {(accordionOpenIndex === index)
                                  ? <h4 onClick={() => setAccordionFunction()}><i></i></h4>
                                  : <h5 onClick={() => setAccordionFunction(index)}><i></i></h5>
                                }
                              </div>
                              {items.orderStatus === "REQUESTED" && <div className='action-items'>
                                <div onClick={() => editPickupRequestOrder(items)}>
                                  <EditIcon width="20" />
                                </div>
                                <div onClick={() => deleteRequestOrderConfirmation(items)}>
                                  <DeleteIcon />
                                </div>
                              </div>}
                            </>
                            :
                            <>
                              <div style={{ display: 'flex' }}>
                                <p className='order-status'>
                                  {items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}
                                </p>
                                {(accordionOpenIndex === index) ?
                                  <h4 onClick={() => setAccordionFunction()}><i></i></h4>
                                  : <h5 onClick={() => setAccordionFunction(index)}><i></i></h5>
                                }
                              </div>
                              <div className='action-items'>
                                {(accordionOpenIndex !== index) && <div
                                  onClick={(e) => generatePdfDocument(e, items)}
                                >
                                  <PrinterIcon />
                                </div>}
                                {items.orderStatus === "REQUESTED" && <div
                                  onClick={() => editOrder(items, items.orderRefNumber, 'editFlow')}
                                >
                                  <EditIcon width="20" />
                                </div>}
                                {items.orderStatus === "REQUESTED" && <div
                                  onClick={() => deleteRequestOrderConfirmation(items)}
                                >
                                  <DeleteIcon />
                                </div>}
                                {items.orderStatus === "REQUESTED" && <div>
                                  <MaterialTooltip
                                    placement="top"
                                    enterTouchDelay={0}
                                    arrow
                                    title={
                                      <>
                                        <p><span>Request Modified Details</span></p>
                                        <p>
                                          <span>Modified:</span>
                                          <span>
                                            {items.remark ? " " + items?.pendingRequestOrderAudits[items?.pendingRequestOrderAudits.length - 1]?.lastModified[1] + "/" + items?.pendingRequestOrderAudits[items?.pendingRequestOrderAudits.length - 1]?.lastModified[2] + "/" + items?.pendingRequestOrderAudits[items?.pendingRequestOrderAudits.length - 1]?.lastModified[0] : ""}
                                          </span>
                                        </p>
                                        <p>
                                          <span>Modified By:</span>
                                          <span>
                                            {items.remark && items?.modifiedBy ? " " + items?.modifiedBy : " "}
                                          </span>
                                        </p>
                                      </>
                                    }
                                  ><span><PtPlusPageInfoIcon /></span>
                                  </MaterialTooltip>
                                </div>}
                                {items.orderStatus === "COMPLETE" &&
                                  <div>
                                    <button
                                      title="Payment Adjustment"
                                      className='adjustment-action-btn'
                                      onClick={(e) => {
                                        setPaymentAdjustmentModal(true)
                                        setClickedOrderDetails(items)
                                      }}
                                    >
                                      Adj
                                    </button>
                                  </div>
                                }
                              </div>
                            </>}
                          {items?.orderStatus === 'PENDING' &&
                            <div>
                              <button
                                title="Withdraw Request"
                                className='withdraw-action-btn'
                                onClick={(e) => {
                                  withdrawRequestOrderConfirmation(items)
                                  setClickedOrderDetails(items)
                                }}
                              >
                                <img src={WithdrawIcon} alt='withdraw-request' />
                              </button>
                            </div>
                          }
                        </td>
                      </tr>
                      {accordionOpenIndex === index &&
                        <>
                          <tr className='order-details-wrapper'>
                            <td colspan="2">
                              <div>
                                <h6>Del/PU Complete Address</h6>
                                <p>{`${items.addressDTO?.locationName?.trim()}, ${items.addressDTO?.street?.trim()}, ${items.addressDTO?.city?.trim()}, ${stateConvert(items.addressDTO?.state?.trim()) || items.addressDTO?.state?.trim()}, ${items.addressDTO?.zipCode?.trim()}`}</p>
                              </div>
                            </td>
                            {items?.requestType === 'PickUp' ?
                              <td colspan="1">
                                <div>
                                  <h6>Loading Requirements</h6>
                                  <p>{items.loadingRequirement === 'DROP_TRAILER' ? 'Drop Trailer' : items.loadingRequirement === 'LIVE_LOAD' ? 'Live Load' : 'NA'}</p>
                                </div>
                              </td>
                              :
                              <td colspan="1">
                                <div>
                                  <h6>Equipt.</h6>
                                  <p>{items.equipmentRequirements?.toString()?.replaceAll(",", ", ")}</p>
                                </div>
                              </td>
                            }
                            <td colspan="1">
                              <div>
                                <h6>Order Comments</h6>
                                <p
                                  style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '130px' }}
                                  title={items.remark}>
                                  {items.remark || 'NA'}
                                </p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Inv. No.</h6>
                                <p>{items.invoiceId || 'NA'}</p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Inv. Date</h6>
                                <p>{items?.invoiceDate || 'NA'}</p>
                              </div>
                            </td>
                            {items?.requestType === 'PickUp' && items?.specificationFiles &&
                              <td colspan="1">
                                <div>
                                  <h6></h6>
                                  <p className='bol-download-class' onClick={() => downloadDocsList(items.specificationFiles)}>Download BOL</p>
                                </div>
                              </td>
                            }
                            {items?.requestType === 'Delivery' && items?.bol &&
                              <td colspan="1">
                                <div>
                                  <h6></h6>
                                  <p className='bol-download-class' onClick={() => downloadDocs(items.bol)}>Download BOL</p>
                                </div>
                              </td>
                            }
                            {items?.invoiceId &&
                              <td colspan="1">
                                <div>
                                  <h6></h6>
                                  <p className='bol-download-class' onClick={() => downloadDocs(`${items.invoiceId}.pdf`)}>Download Invoice</p>
                                </div>
                              </td>
                            }
                          </tr>
                          <tr className='order-details-wrapper'>
                            <td colspan="2">
                              <div>
                                <h6>Supplier Name - City, ST</h6>
                                <p>{items?.tenderDetails?.postedTo
                                  ? `${items?.tenderDetails?.postedTo} - ${items?.tenderDetails?.city}, ${items?.tenderDetails?.state}`
                                  : "NA"}
                                </p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Supplier Email</h6>
                                <Tooltip
                                  placement="top"
                                  arrow
                                  title={items?.tenderDetails?.email ? items?.tenderDetails?.email?.join(', ') : 'NA'}
                                  enterTouchDelay={5}
                                  leaveTouchDelay={10000}
                                >
                                  <p style={{ whiteSpace: 'nowrap' }}>{items?.tenderDetails?.email ? items?.tenderDetails?.email[0] : 'NA'}</p>
                                </Tooltip>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Supplier Phone</h6>
                                <Tooltip
                                  placement="top"
                                  arrow
                                  title={(items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? items?.tenderDetails?.phoneNumber?.join(', ') : 'NA'}
                                  enterTouchDelay={5}
                                  leaveTouchDelay={10000}
                                >
                                  <p>{(items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? items?.tenderDetails?.phoneNumber[0] : 'NA'}</p>
                                </Tooltip>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Load Comments</h6>
                                <p
                                  title={items?.tenderDetails?.comment}
                                  style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '130px' }}>
                                  {items?.tenderDetails?.comment || 'NA'}
                                </p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Tender Date</h6>
                                <p>{items?.tenderDetails?.tenderDate || 'NA'}</p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Req Del/PU</h6>
                                <p style={{ whiteSpace: 'nowrap' }}>{items.requestDeliveryDate} {items.deliveryFromTime}-{items.deliveryToTime}</p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6>Update Date</h6>
                                <p>{items?.updatedAt ? moment(items?.updatedAt * 1000).format('MM/DD/YYYY') : 'NA'}</p>
                              </div>
                            </td>
                            <td colspan="1">
                              <div>
                                <h6 style={{ whiteSpace: 'nowrap' }}>Actual Del/PU</h6>
                                <p>{items?.actualDeliveryDate !== 0 ? moment(items?.actualDeliveryDate * 1000).format('MM/DD/YYYY') : 'NA'}</p>
                              </div>
                            </td>
                          </tr>
                        </>
                      }
                    </>)}
                </tbody>
              </Table>
              {finalData && finalData?.length === 0 &&
                <p style={{
                  position: 'absolute',
                  width: '100%',
                  textAlign: 'center',
                  marginTop: '40px'
                }}>No records found</p>
              }
            </OrderDetailsWrapper>

            {finalData?.length !== 0 && <Pagination count={pageCount}
              page={page}
              onChange={handlePageChange}
            />}
          </TableWrapper>
        </div >
        {paymentAdjustmentModal && <Modal
          size="md"
          isOpen={setPaymentAdjustmentModal}
          centered={true}
        >
          <AdjustmentHeader>
            <ModalBody>
              <PaymentAdjustmentModal
                toggle={(e) => {
                  setPaymentAdjustmentModal(false)
                  fetchOrderRequestsList(1, tableSearch);
                }}
                selectedOrderDetails={clickedOrderDetails}
              />
            </ModalBody>
          </AdjustmentHeader>
        </Modal>}
      </div>
      : <p>You are not authorized to view this page.</p>
    }

    <YesNoModal
      isOpen={yesNoModalOpen}
      toggle={yesNoToggleModal}
      title=""
      onClickHander={(val) => {
        if (val === "no") {
          yesNoToggleModal()
        } else {
          if (yesNoModalAlertType === 'deleteRequestOrder' || yesNoModalAlertType === 'deletePickupRequestOrder') {
            deleteRequestOrderFunction(yesNoModalAlertType)
            yesNoToggleModal()
          }
        }
      }}
      content={yesNoModalContent}
      link="/"
    />

    <ConfirmationModal
      isOpen={yesNomodal}
      toggle={() => {
        setYesNoModal(!yesNomodal);
        setConfirmationComment("");
      }}
      onClickHander={(val) => {
        if (val === "no") {
        } else {
          if (yesNoModalAlertType === 'withdrawPickupRequestOrder' || yesNoModalAlertType === 'withdrawRequestOrder') {
            withdrawRequestOrderFunction(yesNoModalAlertType)
            setYesNoModal(!yesNomodal);
            setConfirmationComment('')
          }
        }
      }}
      showCommentText={true}
      content={yesNoModalContent}
      confirmationComment={confirmationComment}
      setconfirmationComment={setConfirmationComment}
    />

    <AlertModal
      isOpen={alertModal}
      toggle={() => setAlertModal(!alertModal)}
      title=''
      content={alertModalContent}
      alertType={alertType}
      link=''
      callBackAlert={(val) => {
        if (modalResult === 'successDelete' || modalResult === 'successWithdraw') {
          setModalResult('')
          toggleModal()
          fetchOrderRequestsList(page, tableSearch)
        } else toggleModal()
      }}
    />
  </>
};

export default PTPlusOrderRequestManagement;
